module.exports = __webpack_public_path__ + "static/media/Altendorf_F_45_Prospekt_gb.b4a5c906.pdf";